<template>
    <main class="relative mt-20">
        <div class="rounded-lg" id="zaptime-container"></div>
    </main>
</template>

<script lang="ts" setup>
import { useScriptTag } from "@vueuse/core";
import { EventTypeGroup } from "../../App/EventTypes/EventTypes.vue";
const props = defineProps<{
    eventTypeGroup: EventTypeGroup;
}>();

useScriptTag("https://iframe.zaptime.app/zaptime.js", () => {
    //@ts-expect-error
    Zaptime({
        type: "group",
        config: { token: props.eventTypeGroup.token },
    }).render("#zaptime-container");
});
</script>
